import {HealthGuideServicesTypeEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useAccountInformation, useQueryParams} from 'presentation/pages';
import React, {Fragment} from 'react';

import {EarlyAccessAlert} from '../EarlyAccessAlert';
import {ExamAlert} from '../ExamAlert';
import {ProvidersResultsV1} from './components/ProvidersResultsV1';
import {HealthProvidersResultsV1Props} from './types';

export function HealthProvidersResultsV1(props: HealthProvidersResultsV1Props) {
	const {isEarlyAccess} = useAccountInformation();
	const {SEARCH_PARAMS} = useQueryParams();

	const {serviceType, comingFrom} = SEARCH_PARAMS;

	const showExamAlert =
		comingFrom === FlowEnum.EXAM &&
		serviceType === HealthGuideServicesTypeEnum.AUXILIARY_SERVICES;

	return (
		<Fragment>
			{showExamAlert ? <ExamAlert /> : null}
			{isEarlyAccess ? <EarlyAccessAlert /> : null}

			<ProvidersResultsV1 {...props} />
		</Fragment>
	);
}
